import React from 'react'

interface HighlightedTextProps {
  text: string
  searchQuery?: string
}

export const HighlightedText: React.FC<HighlightedTextProps> = ({
  text,
  searchQuery,
}) => {
  if (!searchQuery || !searchQuery.trim()) {
    return <>{text}</>
  }

  // Split search query into individual terms and escape regex special chars
  const terms = searchQuery
    .trim()
    .split(/\s+/)
    .map(term => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .filter(term => term.length > 0)

  if (terms.length === 0) {
    return <>{text}</>
  }

  // Create regex pattern that matches any of the search terms (case insensitive)
  const pattern = new RegExp(`(${terms.join('|')})`, 'gi')
  const parts = text.split(pattern)

  return (
    <>
      {parts.map((part, index) => {
        // Check if this part matches any search term (case insensitive)
        const isMatch = terms.some(
          term => part.toLowerCase() === term.toLowerCase(),
        )

        if (isMatch) {
          return (
            <mark
              key={index}
              className="bg-highlight text-highlight-foreground rounded px-0.5"
            >
              {part}
            </mark>
          )
        }

        return <React.Fragment key={index}>{part}</React.Fragment>
      })}
    </>
  )
}
